module.exports = __webpack_public_path__ + "img/question-circle.9919c2b5.svg";